export default {
    "forgetpassword": "忘記密碼嗎？請點此。",
    "login_troubleloggingin": "無法登入嗎？"
}